export enum Permissions {
  HomePage_Student_Chart = '2', //الصفحة الرئيسية - تقارير الطلاب
  HomePage_Teacher_Chart = '3', //الصفحة الرئيسية - تقارير المعلمين
  HomePage_Bill_Chart = '4', //الصفحة الرئيسية - تقارير الفواتير
  HomePage_Minutes_Chart = '5', //الصفحة الرئيسية - تقارير الدقائق والارصدة
  HomePage_OnLineTeacher_Chart = '6', //الصفحة الرئيسية - المعلمين المتاحين حاليا
  HomePage_OnLineStudent_Chart = '7', //الصفحة الرئيسية - المعلمين المتاحين حاليا
  HomePage_Teacher_Message = '8', //الرسائل - رسائل المعلمين
  HomePage_Student_Message = '9', //الرسائل - رسائل الطلاب
  HomePage_Peak_Message = '10', //الرسائل - الذروة
  HomePage_Student_Report = '11', //التقارير - الطلاب المسجلين
  HomePage_Teacher_Report = '12', //التقارير - المعلمين المسجلين
  HomePage_Calls_Report = '13', //التقارير - المكالمات الواردة
  HomePage_MissedCalls_Report = '14', //التقارير - المكالمات الفائته
  HomePage_GeneralCalls_Report = '15', //التقارير - المكالمات عامة
  HomePage_TeacherPerformance = '16', //التقارير - اداء المعلمين
  HomePage_Reviews = '17', //التقارير - التقييمات
  HomePage_Reports = '18', //التقارير - البلاغات
  HomePage_AppReport = '19', //التقارير - تقرير تحليلات التطبيق
  HomePage_AddTeacher = '20', //تسجيل معلم جديد - اضافة معلم جديد
  HomePage_CALLS_REPORT_CHART = '22', //تقرير المكالمات رسم بيانى
  HomePage_PEAKTIME_Report_Chart = '23', //تقرير وقت الذروة
  //upload
  UploadDate_Teacher = '25', //رفع ملف معلمين
  UploadDate_Student = '26', //رفع ملف طلاب
  UploadDate_Student_Plan = '27',
  UploadDate_Update_Student = '28', //رفع ملف تعديل طلاب
  //user management
  User_Management_Upgrade_Students_Request = '30',
  User_Management_Upgrade_DependentManager_Requests = '31',
  User_Management_Update_Teacher_Request_Info = '32',
  User_Management_Admin_Users = '33',
  User_Management_Report_Student = '34',
  User_Management_Report_Teacher = '35',
  User_Management_Disable_Student_Buy = '36',
  User_Management_Disable_Student_Call = '37',
  User_Management_Disable_Student_Account = '38',
  User_Management_Student_Category = '39',
  User_Management_Student_Disable_Recording = '40',
  User_Management_Disable_Student_Reservation = '41',
  User_Management_View_Student_Dependents = '42',
  User_Management_Grant_Management = '43',
  User_Management_Reset_Password = '44',
  User_Management_Reset_Balance = '45',
  User_Management_Reset_Rating_teacher = '46',
  User_Management_Disable_Teacher_Account = '47',
  User_Management_Teacher_Category = '48',
  User_Management_Teacher_Receivables = '49',
  User_Management_Student_Packages = '50',
  User_Management_Teacher_Join_US = '51',
  User_Management_Delete_Teacher = '53',
  User_Management_Student_Join_US = '119',
  User_Management_Beneficiaries = '52',
  User_Management_Edit_Beneficiary_Balance = '127',
  USER_MANAGEMENT_SET_TEMP_PASSWORD = '109',
  USER_MANAGEMENT_VIEW_DEVICE_INFO = '110',
  User_Management_Admin_Users_Customer_Service = '111',
  //sessions
  Session_Records_Male = '54',
  Session_Records_Female = '55',
  Session_Records_Boy = '56',
  Session_Records_Girl = '57',
  Session_Evaluate_Male = '58',
  Session_Evaluate_Female = '59',
  Session_Update_Session_Record = '60',
  //settings
  Setting_General = '62',
  Setting_Banner = '63',
  Setting_Add_Student_Package = '64',
  Setting_Add_Promo_Package = '66',
  Setting_Add_Special_Student_Package = '67',
  Setting_Add_Promo = '68',
  Setting_Category = '69',
  Setting_Peak_Hour = '70',
  Setting_Dynamic_Link = '71',
  Setting_Call_Shared_Files = '73',
  Setting_Help_FAQs = '74',
  Setting_Help_FAQs_ADD_EDIT = '75',
  Setting_Help_Categories = '76',
  Setting_System_Config = '113',
  // reports
  Reports_Teacher = '79',
  Reports_Student = '80',
  Reports_Call = '81',
  Reports_Detailed_Call = '82',
  Reports_Blocked_Student = '83',
  Reports_Performance_Teacher = '84',
  Reports_Reviews = '85',
  Reports_Admin_Reviews = '86',
  Reports_Admin_Reviews_Approve = '87',
  Reports_Admin_Reviews_Edit = '88',
  Reports_Dependent = '89',
  Reports_Student_Packages = '90',
  Reports_Sessions = '91',
  Reports_OnlineMinutes_Teacher = '92',
  Reports_PeakTime = '93',
  Reports_NotificationReport = '94',
  Reports_Reservation = '95',
  Reports_PaymentTransaction = '96',
  Reports_Firebase = '97',
  Reports_Performance_Student = '98',
  Reports_Student_Info = '99',
  Reports_App_Rating = '100',
  Reports_Survey = '101',
  Reports_Insolvent_Requests = '102',
  Reports_Products_Payments = '103',
  Reports_Student_Plans = '104',
  Reports_Delete_Students_Plans = '105',
  Send_Insolvent_Code = '106',
  Reports_Donations = '112',
  Reports_Beneficiaries = '115',
  Reports_Total_Duration = '118',
  Reports_Teacher_Reservation = '120',
  Reports_Free_codes = '121',
  Reports_Teachers_plans = '122',
  //admin
  Admin_Category = '107',
  Admin = '108',
  // Exported reports
  Setting_Exported_Report = '72',
  // marketplace
  Setting_Products = '77',
  Setting_Package = '65',
  //statistics
  Statistics = '116',
  //send msg
  HomePage_SendMessage = '21',
  //fatiha request
  Fatiha_Requests = '124',
  Fatiha_Requests_Decision = '125',
  Fatiha_Sessions = '126',
}
